/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Multi-source reputation types for Ghost Score */
export enum ReputationSourceType {
  AccountAge,
  X402Transactions,
  UserReviews,
  ElizaOSReputation,
  CrossmintVerification,
  EndpointReliability,
  JobCompletions,
  SkillEndorsements,
}

export type ReputationSourceTypeArgs = ReputationSourceType;

export function getReputationSourceTypeEncoder(): FixedSizeEncoder<ReputationSourceTypeArgs> {
  return getEnumEncoder(ReputationSourceType);
}

export function getReputationSourceTypeDecoder(): FixedSizeDecoder<ReputationSourceType> {
  return getEnumDecoder(ReputationSourceType);
}

export function getReputationSourceTypeCodec(): FixedSizeCodec<
  ReputationSourceTypeArgs,
  ReputationSourceType
> {
  return combineCodec(
    getReputationSourceTypeEncoder(),
    getReputationSourceTypeDecoder(),
  );
}
